module.exports = __webpack_public_path__ + "static/media/verification.e5fb09e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/guide/verification.svg
// module id = 583
// module chunks = 0